// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/storefront/v1/subdomain_claim.proto (package kitecorp.transferify.storefront.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/storefront/v1/subdomain_claim.proto.
 */
export const file_kitecorp_transferify_storefront_v1_subdomain_claim: GenFile = /*@__PURE__*/
  fileDesc("CjhraXRlY29ycC90cmFuc2ZlcmlmeS9zdG9yZWZyb250L3YxL3N1YmRvbWFpbl9jbGFpbS5wcm90bxIia2l0ZWNvcnAudHJhbnNmZXJpZnkuc3RvcmVmcm9udC52MSJeCg5TdWJkb21haW5DbGFpbRINCgVsYWJlbBgBIAEoCRINCgVob3N0cxgCIAMoCRIuCgpjbGFpbWVkX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCIaChhHZXRTdWJkb21haW5DbGFpbVJlcXVlc3QiXgoZR2V0U3ViZG9tYWluQ2xhaW1SZXNwb25zZRJBCgVjbGFpbRgBIAEoCzIyLmtpdGVjb3JwLnRyYW5zZmVyaWZ5LnN0b3JlZnJvbnQudjEuU3ViZG9tYWluQ2xhaW0iJgoVQ2xhaW1TdWJkb21haW5SZXF1ZXN0Eg0KBWxhYmVsGAEgASgJIlsKFkNsYWltU3ViZG9tYWluUmVzcG9uc2USQQoFY2xhaW0YASABKAsyMi5raXRlY29ycC50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxLlN1YmRvbWFpbkNsYWltIhkKF1JlbGVhc2VTdWJkb21haW5SZXF1ZXN0MsEDChVTdWJkb21haW5DbGFpbVNlcnZpY2USngEKEUdldFN1YmRvbWFpbkNsYWltEjwua2l0ZWNvcnAudHJhbnNmZXJpZnkuc3RvcmVmcm9udC52MS5HZXRTdWJkb21haW5DbGFpbVJlcXVlc3QaPS5raXRlY29ycC50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxLkdldFN1YmRvbWFpbkNsYWltUmVzcG9uc2UiDJACAYq1GAUKA3VzZRKSAQoOQ2xhaW1TdWJkb21haW4SOS5raXRlY29ycC50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxLkNsYWltU3ViZG9tYWluUmVxdWVzdBo6LmtpdGVjb3JwLnRyYW5zZmVyaWZ5LnN0b3JlZnJvbnQudjEuQ2xhaW1TdWJkb21haW5SZXNwb25zZSIJirUYBQoDdXNlEnIKEFJlbGVhc2VTdWJkb21haW4SOy5raXRlY29ycC50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxLlJlbGVhc2VTdWJkb21haW5SZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5IgmKtRgFCgN1c2VCSQowY29tLmtpdGVjb3JwLmNvbnRyYWN0cy50cmFuc2ZlcmlmeS5zdG9yZWZyb250LnYxQhNTdWJkb21haW5DbGFpbVByb3RvUAFiBnByb3RvMw", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_kitecorp_options_v1_options]);

/**
 * The label an account holds.
 *
 * @generated from message kitecorp.transferify.storefront.v1.SubdomainClaim
 */
export type SubdomainClaim = Message<"kitecorp.transferify.storefront.v1.SubdomainClaim"> & {
  /**
   * The label.
   *
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * The origins the label serves, one per brand that has a claimed form, built by the server.
   *
   * @generated from field: repeated string hosts = 2;
   */
  hosts: string[];

  /**
   * When the label was claimed.
   *
   * @generated from field: google.protobuf.Timestamp claimed_at = 3;
   */
  claimedAt?: Timestamp | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.SubdomainClaim.
 * Use `create(SubdomainClaimSchema)` to create a new message.
 */
export const SubdomainClaimSchema: GenMessage<SubdomainClaim> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_subdomain_claim, 0);

/**
 * Asks for the claim of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.GetSubdomainClaimRequest
 */
export type GetSubdomainClaimRequest = Message<"kitecorp.transferify.storefront.v1.GetSubdomainClaimRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.GetSubdomainClaimRequest.
 * Use `create(GetSubdomainClaimRequestSchema)` to create a new message.
 */
export const GetSubdomainClaimRequestSchema: GenMessage<GetSubdomainClaimRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_subdomain_claim, 1);

/**
 * The claim of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.GetSubdomainClaimResponse
 */
export type GetSubdomainClaimResponse = Message<"kitecorp.transferify.storefront.v1.GetSubdomainClaimResponse"> & {
  /**
   * The claim. Absent while the account holds none.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.SubdomainClaim claim = 1;
   */
  claim?: SubdomainClaim | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.GetSubdomainClaimResponse.
 * Use `create(GetSubdomainClaimResponseSchema)` to create a new message.
 */
export const GetSubdomainClaimResponseSchema: GenMessage<GetSubdomainClaimResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_subdomain_claim, 2);

/**
 * Names the label to claim.
 *
 * @generated from message kitecorp.transferify.storefront.v1.ClaimSubdomainRequest
 */
export type ClaimSubdomainRequest = Message<"kitecorp.transferify.storefront.v1.ClaimSubdomainRequest"> & {
  /**
   * The label, without a zone.
   *
   * @generated from field: string label = 1;
   */
  label: string;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.ClaimSubdomainRequest.
 * Use `create(ClaimSubdomainRequestSchema)` to create a new message.
 */
export const ClaimSubdomainRequestSchema: GenMessage<ClaimSubdomainRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_subdomain_claim, 3);

/**
 * The claim just made.
 *
 * @generated from message kitecorp.transferify.storefront.v1.ClaimSubdomainResponse
 */
export type ClaimSubdomainResponse = Message<"kitecorp.transferify.storefront.v1.ClaimSubdomainResponse"> & {
  /**
   * The claim, with the origins it serves.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.SubdomainClaim claim = 1;
   */
  claim?: SubdomainClaim | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.ClaimSubdomainResponse.
 * Use `create(ClaimSubdomainResponseSchema)` to create a new message.
 */
export const ClaimSubdomainResponseSchema: GenMessage<ClaimSubdomainResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_subdomain_claim, 4);

/**
 * Asks to release the claim.
 *
 * @generated from message kitecorp.transferify.storefront.v1.ReleaseSubdomainRequest
 */
export type ReleaseSubdomainRequest = Message<"kitecorp.transferify.storefront.v1.ReleaseSubdomainRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.ReleaseSubdomainRequest.
 * Use `create(ReleaseSubdomainRequestSchema)` to create a new message.
 */
export const ReleaseSubdomainRequestSchema: GenMessage<ReleaseSubdomainRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_subdomain_claim, 5);

/**
 * The label a sender claims under Transferify's own zones, such as acme for acme.transferify.eu
 * (kitecorp/contracts#74). Each call reads or changes the one claim of the signed-in account.
 *
 * @generated from service kitecorp.transferify.storefront.v1.SubdomainClaimService
 */
export const SubdomainClaimService: GenService<{
  /**
   * Reads the claim of the signed-in account.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.SubdomainClaimService.GetSubdomainClaim
   */
  getSubdomainClaim: {
    methodKind: "unary";
    input: typeof GetSubdomainClaimRequestSchema;
    output: typeof GetSubdomainClaimResponseSchema;
  },
  /**
   * Claims a label, which serves at once. A malformed or reserved label is refused, and so is one another account
   * holds. The claims are limited per client address.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.SubdomainClaimService.ClaimSubdomain
   */
  claimSubdomain: {
    methodKind: "unary";
    input: typeof ClaimSubdomainRequestSchema;
    output: typeof ClaimSubdomainResponseSchema;
  },
  /**
   * Releases the claim, so the label is free to claim again. A claim an operator has switched off is refused.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.SubdomainClaimService.ReleaseSubdomain
   */
  releaseSubdomain: {
    methodKind: "unary";
    input: typeof ReleaseSubdomainRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_storefront_v1_subdomain_claim, 0);

